const PUBLIC_AUTH_EXACT = new Set([
  '/login',
  '/verify',
  '/prep-request',
  '/substitution-request',
  '/admin/verify',
  '/email/action',
])

export function isPublicAuthPath(pathname: string): boolean {
  if (PUBLIC_AUTH_EXACT.has(pathname)) return true
  return (
    pathname.startsWith('/login/') ||
    pathname.startsWith('/teacher/collection/') ||
    pathname.startsWith('/teacher/commit/') ||
    pathname.startsWith('/auth/engineer/') ||
    pathname.startsWith('/pay/') ||
    pathname.startsWith('/timetable-export/open/')
  )
}

export function shouldBootstrapStoredSession(pathname: string): boolean {
  if (pathname === '/login' || pathname.startsWith('/login/')) return true
  return !isPublicAuthPath(pathname)
}

export function isSafeInternalPath(path: string): boolean {
  return path.startsWith('/') && !path.startsWith('//') && !path.includes('://')
}
